// Frontend-level config. Update these values to change site-wide settings.

// WhatsApp contact number used by the floating button.
// Set the digits only, no plus sign or spaces. Falls back to an env var if set.
export const WHATSAPP_NUMBER =
    process.env.REACT_APP_WHATSAPP_NUMBER || "0000000000";

export const WHATSAPP_MESSAGE =
    "Hi Adx Fusion, I would like to talk about marketing for my brand.";

export const SOCIAL_LINKS = {
    linkedin: "https://www.linkedin.com/company/adx-fusion/",
    instagram: "https://www.instagram.com/adxfuzion/",
    x: "https://x.com/adxfusion",
    facebook: "https://web.facebook.com/profile.php?id=61591583367896",
};
